














































































































































export default function (Component) {
  Component.options.__source = "src/layout/header-only/layout.vue"
}
